import DownLoad from './DownLoad'
import './index.less'

export default DownLoad
